import { AiAgentConfigCapabilities } from '@sharefiledev/safregistry-pilet-sdk';
import {
	AiAgentConfigContextProvider,
	useAiAgentConfigContext,
} from '../context/AiAgentConfigContext';

export const aiAgentConfigCapabilities: AiAgentConfigCapabilities = {
	withAiAgentConfigContext: (contextProps, children) => {
		return (
			<AiAgentConfigContextProvider {...contextProps}>
				{children}
			</AiAgentConfigContextProvider>
		);
	},
	useAiAgentConfigContext: () => {
		return useAiAgentConfigContext();
	},
};
